module.exports = __webpack_public_path__ + "assets/img/2111591934007_.pic_hd.535b538c.jpg";